import { Layers, CheckCircle, Zap, Brain, AlertTriangle, FileText } from "lucide-react";

export default function ProjectStats({ project, counts }) {
  const stats = [
    {
      label: "Total",
      value: counts?.total ?? project?.total_segments ?? 0,
      icon: <Layers className="w-4 h-4" strokeWidth={1.5} />,
      color: "#E0E0E0",
      bg: "rgba(224, 224, 224, 0.05)",
    },
    {
      label: "TM 100%",
      value: counts?.tm_100 ?? project?.tm_100_count ?? 0,
      icon: <CheckCircle className="w-4 h-4" strokeWidth={1.5} />,
      color: "#39FF14",
      bg: "rgba(57, 255, 20, 0.05)",
    },
    {
      label: "Fuzzy",
      value: counts?.tm_fuzzy ?? project?.tm_fuzzy_count ?? 0,
      icon: <Zap className="w-4 h-4" strokeWidth={1.5} />,
      color: "#FFB800",
      bg: "rgba(255, 184, 0, 0.05)",
    },
    {
      label: "AI",
      value: counts?.ai_translated ?? project?.ai_translated_count ?? 0,
      icon: <Brain className="w-4 h-4" strokeWidth={1.5} />,
      color: "#00F0FF",
      bg: "rgba(0, 240, 255, 0.05)",
    },
    {
      label: "New",
      value: counts?.new ?? project?.new_count ?? 0,
      icon: <FileText className="w-4 h-4" strokeWidth={1.5} />,
      color: "#94A3B8",
      bg: "rgba(148, 163, 184, 0.05)",
    },
    {
      label: "Flagged",
      value: counts?.flagged ?? 0,
      icon: <AlertTriangle className="w-4 h-4" strokeWidth={1.5} />,
      color: "#FF003C",
      bg: "rgba(255, 0, 60, 0.05)",
    },
  ];

  const total = counts?.total ?? project?.total_segments ?? 1;
  const translated = (counts?.tm_100 ?? 0) + (counts?.tm_fuzzy ?? 0) + (counts?.ai_translated ?? 0) + (counts?.reviewed ?? 0);
  const progress = total > 0 ? Math.round((translated / total) * 100) : 0;

  return (
    <div data-testid="project-stats">
      {/* Progress bar */}
      <div className="mb-4">
        <div className="flex items-center justify-between mb-1.5">
          <span className="text-xs font-ui text-[#94A3B8] uppercase tracking-wider">Translation Progress</span>
          <span className="text-xs font-mono text-neon-cyan">{progress}%</span>
        </div>
        <div className="w-full h-1.5 bg-surface-300 rounded-full overflow-hidden">
          <div
            className="h-full bg-neon-cyan rounded-full transition-all duration-500"
            style={{
              width: `${progress}%`,
              boxShadow: '0 0 8px rgba(0, 240, 255, 0.5)',
            }}
          />
        </div>
      </div>

      {/* Stats grid */}
      <div className="grid grid-cols-3 sm:grid-cols-6 gap-2">
        {stats.map((stat) => (
          <div
            key={stat.label}
            className="p-3 rounded-sm border border-[#2A2F3A]/50 hover:border-[#4A5568]/50 transition-colors duration-200"
            style={{ background: stat.bg }}
          >
            <div className="flex items-center gap-1.5 mb-1" style={{ color: stat.color }}>
              {stat.icon}
              <span className="text-[10px] font-ui font-medium uppercase tracking-wider">{stat.label}</span>
            </div>
            <p className="text-xl font-heading font-bold" style={{ color: stat.color }}>
              {stat.value}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
